import React from "react";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Divider } from "../../../designSystem/Divider";
import { Label } from "../../../designSystem/Label";
import { P, Small } from "../../../designSystem/typography/Body";
import { H1, H2 } from "../../../designSystem/typography/Heading";
import { SimpleFieldChangePanel, TextFieldChangePanel } from '../../../designSystem/FieldChangePanel';
import { Card } from "../../../designSystem/Card";

export const FieldChangePanelOverview = (): JSX.Element =>
{
    return (
        <>
            <Flex flexDirection="column" gap={16}>

                <H1>FieldChangePanel</H1>

                <H2>SimpleFieldChangePanel - defaultOpen undefined</H2>
                <Card variant="outlined">
                    <SimpleFieldChangePanel
                        oldValue="Den gamle værdi"
                        newValue="Den nye værdi"
                    />
                </Card>

                <H2>SimpleFieldChangePanel - defaultOpen false</H2>
                <Card variant="outlined">
                    <SimpleFieldChangePanel
                        oldValue="Den gamle værdi"
                        newValue="Den nye værdi"
                        defaultOpen={false}
                    />
                </Card>

                <H2>SimpleFieldChangePanel - defaultOpen true</H2>
                <Card variant="outlined">
                    <SimpleFieldChangePanel
                        oldValue="Den gamle værdi"
                        newValue="Den nye værdi"
                        defaultOpen={true}
                    />
                </Card>
                
                <H2>SimpleFieldChangePanel - no change (invisible)</H2>
                <Card variant="outlined">
                    <SimpleFieldChangePanel
                        oldValue="Den gamle værdi"
                        newValue="Den gamle værdi"
                    />
                </Card>

                <H2>TextFieldChangePanel - character diff - defaultOpen</H2>
                <Card variant="outlined">
                    <TextFieldChangePanel
                        diffMode="characters"
                        oldText="Den gamle værdi"
                        newText="Her er den nye værdi med lidt ekstra"
                        defaultOpen
                    />
                </Card>

                <H2>TextFieldChangePanel - word diff - defaultOpen</H2>
                <Card variant="outlined">
                    <TextFieldChangePanel
                        diffMode="words"
                        oldText="Den gamle værdi"
                        newText="Her er den nye værdi med lidt ekstra"
                        defaultOpen
                    />
                </Card>

                <H2>TextFieldChangePanel - sentence diff - defaultOpen</H2>
                <Card variant="outlined">
                    <TextFieldChangePanel
                        diffMode="sentences"
                        oldText="Den gamle værdi"
                        newText="Her er den nye værdi. Med lidt ekstra"
                        defaultOpen={true}
                    />
                </Card>

                <H2>TextFieldChangePanel - no diff (invisible)</H2>
                <Card variant="outlined">
                    <TextFieldChangePanel
                        diffMode="sentences"
                        oldText="Den gamle værdi"
                        newText="Den gamle værdi"
                    />
                </Card>
                    
                <div>
                    <P>P - Body</P>
                </div>

                <Divider />

                <div>
                    <div>
                        <Small>Small - body</Small>
                    </div>

                    <div>
                        <Small>Some more small text...</Small>
                    </div>
                </div>

                <Divider />

                <div>
                    <Label>Label</Label>
                </div>

            </Flex>
        </>
    );
};